import React from 'react';
import { Tooltip } from 'antd';
import './Status.css'

export const Status = ({status, text, blink, tooltipText, tooltipPlacement, defaultOpen, trigger, open, visible, labelStyle, dotStyle, size, bordered, ...props}) => {

    const allowBlink = blink ? 'animate-blink' : '';
    const allowBordered = bordered ? 'status-bordered' : '';
    
    const statusLabel = <p className='status-label' style={labelStyle}>{text}</p>;

    const dot = {
        height: size, 
        width: size,
        ...dotStyle,
    }

    const statusType = () => {
        let type;
        switch (status) {
            case 'default':
                type = 'default'
                break;
            case true:
                type = 'success'
                break;
            case false:
                type = 'error'
                break;
            default:
                type='default'
                break;
        }
        return type;
    }
    
    const statusElement = (
        <div {...props} className={`${props.className || ''} status status-${statusType()} ${allowBlink} ${allowBordered}`} >
            <span className='status-dot' style={dot}></span>
            { text ? statusLabel : ''}
        </div>
    );

    return(
        <>
            { 
                tooltipText ? 
                    <Tooltip title={tooltipText} placement={tooltipPlacement} defaultOpen={defaultOpen} trigger={trigger} open={visible || undefined}>
                        {statusElement}
                    </Tooltip>
                :
                    statusElement
            }
        </>
    );
}

Status.defaultProps = {
    blink: false,
    status: false,
    text: '', 
    tooltipText: '',
    labelStyle: {},
    dotStyle: {},
    bordered: false,
    tooltipPlacement: 'top',
    defaultOpen: false,
    trigger: 'hover',
    open: false,
    size: 15,
}